<template>
  <v-simple-table class="px-5" v-if="Object.keys(tableData).length != 0">
    <template v-slot:default>
      <!-- <div placeholder="{{ 'Merchandise' | translate }}"></div> -->
      <!-- <div placeholder="{{ 'Donation' | translate }}"></div> -->
      <!-- <div placeholder="{{ 'Refunded' | translate }}"></div> -->
      <!-- <div placeholder="{{ 'TOTAL' | translate }}"></div> -->
      <thead>
        <tr>
          <th class="text-center"></th>
          <th class="text-center">{{ $t(["Amount"]) }}</th>
          <th class="text-center">{{ $t(["Refunded"]) }}</th>
          <th class="text-center">{{ $t(["Total"]) }}</th>
        </tr>
      </thead>

      <tbody>
        <tr class="text-center" v-if="tableData.type == 'Merchandise'">
          <td class="pl-0">{{ $t(["Merchandise"]) }}</td>
          <td
            v-html="
              $t('Currency', { amount: tableData.merchAmount.toFixed(2) })
            "
          />
          <td
            class="secondary--text"
            v-html="
              '(' +
              $t('Currency', { amount: tableData.merchRefund.toFixed(2) }) +
              ')'
            "
          />
          <td
            v-html="$t('Currency', { amount: tableData.merchTotal.toFixed(2) })"
          />
        </tr>

        <tr class="text-center">
          <td class="pl-0">{{ $t(["Donation"]) }}</td>
          <td
            v-html="
              $t('Currency', { amount: tableData.donationAmount.toFixed(2) })
            "
          />
          <td
            class="secondary--text"
            v-html="
              '(' +
              $t('Currency', { amount: tableData.donationRefund.toFixed(2) }) +
              ')'
            "
          />
          <td
            v-html="
              $t('Currency', { amount: tableData.donationTotal.toFixed(2) })
            "
          />
        </tr>

        <tr class="text-center">
          <td class="pl-0">
            <h2>{{ $t(["Total"]) }}</h2>
          </td>
          <td>
            <h2
              v-html="
                $t('Currency', {
                  amount: (
                    (!isNaN(tableData.merchAmount)
                      ? tableData.merchAmount
                      : 0) + tableData.donationAmount
                  ).toFixed(2),
                })
              "
            />
          </td>
          <td>
            <h2
              class="secondary--text"
              v-html="
                '(' +
                $t('Currency', {
                  amount: (
                    (!isNaN(tableData.merchRefund)
                      ? tableData.merchRefund
                      : 0) + tableData.donationRefund
                  ).toFixed(2),
                }) +
                ')'
              "
            />
          </td>
          <td>
            <h2
              v-html="
                $t('Currency', {
                  amount: (
                    (!isNaN(tableData.merchTotal) ? tableData.merchTotal : 0) +
                    tableData.donationTotal
                  ).toFixed(2),
                })
              "
            />
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  name: "TotalTable",
  props: {
    tableData: undefined,
  },
};
</script>

<style lang="scss" scoped></style>
